module.exports = __webpack_public_path__ + "img/Mariposa.5a66d6a1.png";